<!--
  Created 31.10.2023
  Originated from Tailwind UI component: Overlays, Slide-overs, WithBackgroundOverlay
  https://tailwindui.com/components/application-ui/overlays/slide-overs#component-3e8348c3c183bd14fceb018d4cca1942
-->
<template>
  <TransitionRoot
    as="template"
    :show="slideOpen">
    <Dialog
      as="div"
      class="relative"
      :class="zIndexClass"
      @close="slideOpen = false">
      <TransitionChild
        as="template"
        enter="ease-in-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in-out duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-300 sm:duration-500"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-300 sm:duration-500"
              leave-from="translate-x-0"
              leave-to="translate-x-full">
              <DialogPanel
                class="pointer-events-auto w-screen max-w-md"
                :class="{'!max-w-2xl':isWide}">
                <div class="flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl">
                  <div class="px-4 sm:px-6">
                    <div class="flex items-start justify-between">
                      <DialogTitle class="text-base font-semibold leading-6 text-gray-900">
                        <slot name="title" />
                      </DialogTitle>
                      <div class="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          class="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                          @click="slideOpen = false">
                          <span class="absolute -inset-2.5" />
                          <span class="sr-only">Close panel</span>
                          <XMarkIcon
                            class="h-6 w-6"
                            aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="relative mt-6 flex-1 px-4 sm:px-6">
                    <slot name="content" />
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {
  computed,
} from 'vue';
import {
  Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot,
} from '@headlessui/vue';
import { XMarkIcon } from '@heroicons/vue/24/outline';

const emit = defineEmits(['update:slideOpen']);

const props = defineProps({
  slideOpen: {
    type: Boolean,
    required: true,
    default: false,
  },
  isWide: {
    type: Boolean,
    required: false,
    default: false,
  },
  zIndexClass: {
    type: String,
    required: false,
    default: 'z-50',
  },
});

const slideOpen = computed({
  get: () => props.slideOpen,
  set: (value) => emit('update:slideOpen', value),
});
</script>
